import React from 'react';
import { Field, Form, Formik } from 'formik';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import * as moment from 'moment';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

const DbExportForm = ({ projectDetail, projectId, saveDbExportRequest, toggle }) => {
  const { name, seoName } = projectDetail;
  const handleSubmit = (values) => {
    values.projectId = projectId;
    values.seoName = seoName;
    saveDbExportRequest(values);
  };

  return (
    <Formik
      initialValues={{
        name: `${name}-${moment().format('YYYY-MM-DD-HH-mm-ss-SSS')}`,
      }}
      onSubmit={handleSubmit}
    >
      <Form className="form-horizontal">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <CustomInputWithIcon title="Name" icon="text" required={true}>
              <Field
                type="text"
                name="name"
                placeholder="Name"
                className="form-control form-control-sm"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-12 col-lg-12 mt-2 text-right">
            <button type="submit" className="btn btn-theme-submit btn-md">
              <i className={`wb ${drapcodeIcon('send')}`}></i>&nbsp;Export Dump&nbsp;
            </button>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default DbExportForm;
